/* Speed fix Oct 19 (helper): true when a DOM change is inside the Kaching cart drawer, or adds the drawer itself.
   Used so the cart scripts below ignore the hundreds of changes elsewhere on the page while it loads. */
window.__esmeInCart = window.__esmeInCart || (m => {
  const c = document.getElementById('kaching-cart');
  if (!c) return false;
  if (c.contains(m.target)) return true;
  for (const n of m.addedNodes || []) if (n.nodeType === 1 && (n === c || n.contains(c))) return true;
  return false;
});
/* Esme Belmont · cart auto-bundle (Kaching cart drawer), v5
   1 tank → Buy 2 Get 1 FREE (3 tanks) → Buy 3 Get 2 FREE (5 tanks)
   - tank added / + on a bundle: next tier up; − on a bundle: one tier down; UPGRADE button: window.esmeUpgradeToBundle()
   - fast path: UPGRADE, and + / − on a plain 1 / 3 / 5-tank cart, go straight to the next / previous bundle
     (1 → 3: one /cart/change.js; otherwise one /cart/update.js + one /cart/add.js), then ONE Kaching refresh
   - cart photos in the drawer load 200px wide instead of full size
   - colour/size swaps (Kaching removes + re-adds a tank, same number of tanks) are ignored: no wait, no /cart.js, no updates
   - a real quantity change gets ONE /cart.js check once no cart request has been in flight for quietMs
   - window.__esmeCart {inflight, n, busy} is read by the cart UI (Kaching Cart › Custom HTML) for the "Updating…" state
   Moved here from Kaching Cart › Custom JS (Kaching's 10 KB limit); that box now only calls window.esmeCartReady(). */
(() => {
  if (window.__esmeAutoBundle) return;
  window.__esmeAutoBundle = true;
  const DEAL = '{"deal":"d7qi","pp":15398076678380,"main":true,"v":"16514c76-1136-4d55-9b9d-b42d207efdcf",';
  const CONFIG = {
    productIds: [15398076678380],
    propKey: '__kaching_bundles',
    /* Buy 1, Buy 2 Get 1 (3), Buy 3 Get 2 (5); templates from /cart.js */
    tiers: [
      {quantity: 1, properties: {__kaching_bundles: DEAL + '"bid":"B7Rp"}'}},
      {quantity: 3, properties: {__kaching_bundles: DEAL + '"id":"sKdU","bid":"N80r"}'}},
      {quantity: 5, properties: {__kaching_bundles: DEAL + '"id":"tE0A","bid":"v-cL"}'}}
    ],
    matchKeys: ['deal', 'bid'],
    regenerateKeys: [], /* e.g. ['id'] to give each rebuilt bundle a fresh value (Kaching uses a fixed id per bar) */
    fixOverflow: true,
    quietMs: 350, /* ONE /cart.js check after the cart is quiet this long */
    confirmMs: 400, /* fallback while a request is in flight */
    debug: false
  };
  const KEY = CONFIG.propKey, TIERS = CONFIG.tiers, TOP = TIERS.length - 1;
  const S = window.__esmeCart = {inflight: 0, n: 0, busy: false}; /* read by the cart UI */
  let busy = false, pending = false, timer = null, applies = [], open = false, touched = null;
  let kFresh = true; /* Kaching's cart data matches the real cart (false from a cart write until Kaching has re-read the cart) */
  document.addEventListener('kaching-cart:cart-updated', () => { kFresh = true; });
  const kData = () => { const d = window.kachingCartApi?.getCartData?.(); return d && Array.isArray(d.items) && d.items.every(i => i.key) ? d : null; };
  const origFetch = window.fetch.bind(window);
  const raw = (...a) => (window.__kachingBundlesRawFetch || origFetch)(...a);
  const log = (...a) => CONFIG.debug && console.log('[esme-bundle]', ...a);
  const parse = v => { try { return JSON.parse(v); } catch (e) { return null; } };
  const identity = p => {
    if (!p || p[KEY] == null || p[KEY] === '') return null;
    const o = parse(p[KEY]);
    return o ? CONFIG.matchKeys.map(k => JSON.stringify(o[k])).join('|') : 'raw:' + p[KEY];
  };
  const TIER_OF = {};
  TIERS.forEach((t, i) => TIER_OF[identity(t.properties)] = i);
  const tierOf = l => TIER_OF[identity(l.properties)] ?? 0; /* untagged = single */
  const props = t => {
    const p = TIERS[t].properties;
    if (!CONFIG.regenerateKeys.length) return p;
    const o = parse(p[KEY]) || {};
    CONFIG.regenerateKeys.forEach(k => { if (k in o) o[k] = Math.random().toString(36).slice(2, 6); });
    return {...p, [KEY]: JSON.stringify(o)};
  };
  const units = lines => lines.flatMap(l => Array(l.quantity).fill(l.variant_id));
  const group = (vars, p) => vars.reduce((a, v) => {
    const l = a[a.length - 1];
    l && l.id === v ? l.quantity++ : a.push({id: v, quantity: 1, properties: p});
    return a;
  }, []);
  const tierFor = n => { for (let t = 0; t < TOP; t++) if (TIERS[t].quantity >= n) return t; return TOP; };
  const build = (vars, n, fill) => {
    const t = tierFor(n), q = TIERS[t].quantity;
    n = Math.max(n, q);
    vars = vars.slice(0, n);
    while (vars.length < n) vars.push(fill);
    return (t ? group(vars.slice(0, q), props(t)) : []).concat((t ? vars.slice(q) : vars).map(v => ({id: v, quantity: 1, properties: TIERS[0].properties})));
  };
  const store = (pid, val) => {
    const k = 'esmeAB_n_' + pid;
    try { if (val === undefined) return parse(sessionStorage.getItem(k)); sessionStorage.setItem(k, val); } catch (e) { return null; }
  };
  /* copy the tank just added/changed */
  const newest = lines => lines.some(l => l.variant_id === touched) ? touched : lines[0].variant_id;

  function plan(cart, force) {
    const out = [];
    CONFIG.productIds.forEach(pid => {
      const lines = cart.items.filter(l => l.product_id === pid);
      if (!lines.length) return store(pid, 0);
      const by = TIERS.map(() => []);
      lines.forEach(l => by[tierOf(l)].push(l));
      const u = by.map(units), all = units(lines), N = all.length, prev = store(pid), nv = newest(lines);
      const bundled = u.map((x, t) => t && x.length ? t : 0).filter(Boolean), top = bundled.pop() || 0;
      const step = (kind, rm, add) => out.push({pid, kind, remove: rm.map(l => l.key), lines: rm, add,
        n: N - units(rm).length + add.reduce((s, a) => s + a.quantity, 0)});
      for (let t = TOP; t >= 1; t--) {
        const c = u[t].length, q = TIERS[t].quantity;
        /* 1. broken bundle (−): one tier down; 3-pack → 1 tank */
        if (c && c < q) return step('down', by[t], t > 1 ? build(u[t], TIERS[t - 1].quantity, nv) : N === c ? build([u[t][0]], 1, nv) : []);
        /* 2. over-full bundle (+): next tier up; top tier: bundle + singles */
        if (c > q && (t < TOP || CONFIG.fixOverflow)) return step('up', by[t], build(u[t], t < TOP ? Math.max(c, TIERS[t + 1].quantity) : c, nv));
      }
      /* 3b. − on a full bundle (fast path): one tier down; 3-pack → its first tank */
      if (force === 'down') return top && !bundled.length && !u[0].length ? step('down', lines, top > 1 ? build(all, TIERS[top - 1].quantity, nv) : build([all[0]], 1, nv)) : undefined;
      if (top < TOP && !bundled.length) {
        /* 3. UPGRADE button / + on a full bundle or 1 tank (fast path): next tier up */
        if (force) return step('up', lines, build(all, Math.max(N, TIERS[top + 1].quantity), nv));
        /* 4. tank added: 2 tanks → 3-pack, 4 → 5-pack */
        if ((prev === null || N > prev) && u[0].length && (top || N >= 2)) return step('up', lines, build(all, N, nv));
      }
      store(pid, N);
    });
    return out;
  }

  /* raw fetch: Kaching Bundles would expand tagged adds */
  const post = (url, body) => raw(url, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)})
    .then(r => { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  const getCart = () => raw('/cart.js?esme=' + Date.now()).then(r => r.json());
  function refreshUI() {
    const k = window.kachingCartApi;
    kFresh = false;
    try { k?.refreshCart?.(); if (open) k?.openCart?.(); } catch (e) { log(e); }
  }
  function apply(steps, cart) {
    const now = Date.now(), updates = {};
    applies = applies.filter(t => now - t < 60000);
    if (applies.length >= 8) return log('paused'), Promise.resolve(false);
    applies.push(now);
    steps.forEach(s => s.remove.forEach(k => updates[k] = 0));
    const adds = steps.flatMap(s => s.add), removed = Object.keys(updates);
    log('apply', steps, updates, adds);
    /* one line becomes one line of the same tank (1 → 3): ONE call. Otherwise remove all old lines in ONE call, then add all new lines in ONE call */
    const one = steps.length === 1 && steps[0].lines.length === 1 && adds.length === 1 && adds[0].id === steps[0].lines[0].variant_id;
    const write = one
      ? post('/cart/change.js', {id: removed[0], quantity: adds[0].quantity, properties: adds[0].properties})
      : (removed.length ? post('/cart/update.js', {updates}) : Promise.resolve()).then(() => adds.length && post('/cart/add.js', {items: adds}));
    return write
      .then(() => { steps.forEach(s => store(s.pid, s.n)); return true; })
      .catch(err => {
        log('restore', err);
        return getCart().then(c => {
          const still = c.items.map(l => l.key);
          const missing = cart.items.filter(l => removed.includes(l.key) && !still.includes(l.key))
            .map(l => ({id: l.variant_id, quantity: l.quantity, properties: l.properties || {}}));
          return missing.length && post('/cart/add.js', {items: missing});
        }).catch(() => {}).then(() => false);
      });
  }
  function run(force) {
    if (busy) return (pending = true), Promise.resolve(false);
    busy = S.busy = true; S.n++;
    /* Speed fix Oct 19: 'init' = first check after page load (see firstCheck); it plans exactly like run(false) */
    const init = force === 'init';
    if (init) force = false;
    /* fast path: use the cart Kaching already has (saves a /cart.js round trip) when it is up to date */
    const d = (force || init) && kFresh && !S.inflight && kData(); /* was: force && kFresh && ... */
    return (d ? Promise.resolve(d) : getCart()).then(cart => {
      const steps = plan(cart, force);
      return steps.length ? apply(steps, cart) : false;
    }).then(ok => { if (ok) refreshUI(); return ok; }, e => { log(e); return false; }).then(ok => {
      busy = false;
      if (pending) { pending = false; schedule(); } else S.busy = !!S.inflight;
      return ok;
    });
  }
  function schedule() {
    open = S.busy = true;
    clearTimeout(timer);
    timer = setTimeout(() => { timer = null; S.inflight ? schedule() : run(false); }, S.inflight ? CONFIG.confirmMs : CONFIG.quietMs);
  }
  const gid = s => +String(s).split('?')[0].split('/').pop();
  /* Kaching's GraphQL cart mutation (lines may be a list or a single object): net change in tanks per deal/bar. All 0 = colour/size swap */
  function swap(body) {
    const v = parse(body)?.variables || {}, items = window.kachingCartApi?.getCartData?.()?.items || [], net = {};
    let ok = true, any = false;
    const add = (id, q) => { net[id] = (net[id] || 0) + q; any = true; };
    [].concat(v.linesToAdd || v.lines || []).filter(l => l && l.merchandiseId).forEach(l => {
      add(identity(Object.fromEntries((l.attributes || []).map(x => [x.key, x.value]))), l.quantity || 1);
      touched = gid(l.merchandiseId);
    });
    [].concat(v.linesToUpdate || [].concat(v.lines || []).filter(l => l && l.id), [].concat(v.lineIds || []).map(id => ({id, quantity: 0}))).forEach(l => {
      const it = items.find(i => i.storefrontApiLineId === l.id);
      if (!it) return (ok = false);
      add(identity(it.properties), l.quantity - it.quantity);
      if (l.quantity > it.quantity) touched = it.variant_id;
    });
    return ok && any && Object.values(net).every(x => !x);
  }
  /* REST /cart/add: remember the tank just added */
  function rest(body) {
    try { const b = typeof body === 'string' ? parse(body) : null, id = b ? b.items?.[0]?.id ?? b.id : body?.get?.('id'); if (id) touched = +id; } catch (e) {}
  }
  function track(p, sw) {
    S.inflight++; S.n++; S.busy = true; kFresh = false;
    const done = () => { S.inflight--; sw ? (!S.inflight && !timer && !busy && (S.busy = false)) : schedule(); };
    p.then(done, done);
    return p;
  }
  const CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  function isCartCall(url, body) {
    url = String(url || '');
    if (/esme=/.test(url)) return false;
    if (CART_RE.test(url)) return true;
    return /graphql/.test(url) && typeof body === 'string' && /cartLines(Add|Update|Remove)|cartCreate|updateCart/.test(body);
  }
  /* Hook fetch/XHR ONCE, after Kaching Cart has installed its own fetch override, so this wrapper sits on top of it
     (Kaching Cart › Custom JS calls window.esmeCartReady()). Never re-hook: Kaching's apps also wrap fetch. */
  function start() {
    if (start.done) return;
    start.done = true;
    const inner = window.fetch;
    window.fetch = function(input, init) {
      const url = typeof input === 'string' ? input : input?.url, body = init?.body, p = inner.apply(window, arguments);
      try { /* never let our bookkeeping break the request (Kaching retries a failed fetch = duplicate tanks) */
        if (!isCartCall(url, body)) return p;
        const sw = /graphql/.test(url) ? swap(body) : (/add/.test(url) && rest(body), false);
        if (sw) log('colour/size swap: no check');
        track(p, sw);
      } catch (e) { log(e); }
      return p;
    };
    const xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(m, url) { this.__esmeUrl = url; return xOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function(body) {
      try { if (isCartCall(this.__esmeUrl, body)) track(new Promise(r => this.addEventListener('loadend', r)), false); } catch (e) { log(e); }
      return xSend.apply(this, arguments);
    };
    firstCheck(); /* Speed fix Oct 19: was run(false) */
  }
  /* Speed fix Oct 19: the first check after page load reads the cart Kaching Cart has just loaded instead of asking
     /cart.js a 3rd time at the same moment. Falls back to /cart.js (the old way) if Kaching has no cart data within 3 s. */
  function firstCheck() {
    const go = () => { if (go.done) return; go.done = true; document.removeEventListener('kaching-cart:cart-updated', go); run('init'); };
    if (kData()) return go();
    document.addEventListener('kaching-cart:cart-updated', go);
    setTimeout(go, 3000);
  }
  window.esmeCartReady = start;
  if (window.__esmeKachingReady) start();
  else window.addEventListener('load', () => setTimeout(start, 4000)); /* fallback if Kaching Cart never calls it */
  window.esmeUpgradeToBundle = (dir) => { clearTimeout(timer); timer = null; open = true; return run(dir === 'down' ? 'down' : true); };

  /* Busy until the drawer shows the new cart: html.esme-upgrading locks Checkout ("UPDATING CART…"), the offer button keeps
     its spinner, the tank row keeps its dimmed look + quantity spinner. Ends when Kaching has the new number of tanks and the
     offer card shows its next state; at once if the change fails; 8 s safety cap */
  let working = false;
  const root = document.documentElement;
  const tanks = () => (kData()?.items || []).filter(i => CONFIG.productIds.includes(i.product_id)).reduce((s, i) => s + i.quantity, 0);
  const checkout = () => document.querySelector('#kaching-cart .kaching-cart__checkout-button');
  const cardState = () => document.querySelector('#kaching-cart .ev2-card')?.className || '';
  function withBusy(job, btn, row) {
    working = true;
    const state0 = cardState(), n0 = tanks(), t0 = Date.now();
    let result = null, iv = 0;
    const set = on => {
      if (btn) { btn.classList.toggle('is-busy', on); btn.disabled = on; on ? btn.setAttribute('aria-busy', 'true') : btn.removeAttribute('aria-busy'); }
      if (row) on ? row.setAttribute('data-esme-busy', '') : row.removeAttribute('data-esme-busy');
      root.classList.toggle('esme-upgrading', on);
      const c = checkout();
      if (c && (on || !root.classList.contains('esme-busy'))) c.disabled = on;
    };
    const finish = () => { clearInterval(iv); set(false); working = false; log('busy', result, Date.now() - t0 + 'ms'); };
    set(true);
    job().then(ok => { result = !!ok; }, () => { result = false; });
    iv = setInterval(() => {
      if (Date.now() - t0 > 8000 || result === false) return finish();
      const c = checkout();
      if (c && !c.disabled) c.disabled = true;
      if (btn) btn.classList.add('is-busy'); /* the "Updating…" helper clears .is-busy when it finishes */
      if (result && !S.inflight && kFresh && tanks() !== n0 && cardState() !== state0) finish();
    }, 20);
  }
  /* Offer button (UPGRADE) */
  document.addEventListener('click', e => {
    const b = e.target.closest?.('[data-esme-upgrade]');
    if (!b) return;
    e.preventDefault();
    if (working || b.disabled) return;
    withBusy(() => window.esmeUpgradeToBundle(), b, null);
  });
  /* + / − on a plain 1, 3 or 5-tank cart (one row for the tank): go straight to the next / previous bundle instead of letting
     Kaching change the quantity first and fixing it afterwards. Anything else (5-pack +, single −, other products) stays with Kaching. */
  const path = u => { try { return new URL(u, location.href).pathname.replace(/\/$/, ''); } catch (e) { return ''; } };
  document.addEventListener('click', e => {
    const q = e.target.closest?.('#kaching-cart .kaching-cart-item__quantity-btn');
    const row = q && q.closest('.kaching-cart-item');
    if (!row) return;
    const dir = q.classList.contains('kaching-cart-item__quantity-btn--increment') ? 'up' : q.classList.contains('kaching-cart-item__quantity-btn--decrement') ? 'down' : '';
    try {
      if (working) { e.stopPropagation(); e.preventDefault(); return; } /* a bundle change is already running: ignore extra taps */
      const cart = kFresh && !S.inflight && !busy && kData();
      const link = path(row.querySelector('a[href*="/products/"]')?.getAttribute('href'));
      const item = cart && link && cart.items.find(i => CONFIG.productIds.includes(i.product_id) && path(i.url) === link);
      if (!dir || !item) return;
      const lines = cart.items.filter(i => i.product_id === item.product_id), ts = [...new Set(lines.map(tierOf))], t = ts[0];
      const n = lines.reduce((s, i) => s + i.quantity, 0);
      const rows = [...document.querySelectorAll('#kaching-cart .kaching-cart-item')].filter(r => path(r.querySelector('a[href*="/products/"]')?.getAttribute('href')) === link);
      if (ts.length !== 1 || rows.length !== 1 || n !== TIERS[t].quantity || (dir === 'up' ? t >= TOP : t < 1)) return;
      e.stopPropagation(); e.preventDefault();
      withBusy(() => window.esmeUpgradeToBundle(dir), null, row);
    } catch (err) { log(err); }
  }, true);

  /* Cart photos: ask Shopify's CDN for a 200px-wide copy (Kaching uses the full-size photo: 3000px, ~275 KB each) */
  const thumbs = () => document.querySelectorAll('#kaching-cart img.kaching-cart-item__image').forEach(img => {
    const src = img.getAttribute('src') || '';
    if (src && !/[?&]width=/.test(src) && /cdn\.shopify\.com|\/cdn\/shop\//.test(src)) img.setAttribute('src', src + (src.includes('?') ? '&' : '?') + 'width=200');
  });
  /* Speed fix Oct 19: only react to changes inside the Kaching cart, and at most once per frame (was: every change on the page) */
  let thumbsQ = false;
  new MutationObserver(ms => { if (!thumbsQ && ms.some(m => (m.addedNodes.length || m.attributeName === 'src') && window.__esmeInCart(m))) { thumbsQ = true; requestAnimationFrame(() => { thumbsQ = false; thumbs(); }); } })
    .observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['src']});
})();

/* Cart photo: every Esme Shaper Tank line always shows the product's main photo (nude front), never the variant photo.
   The <img> is never reloaded: when Kaching re-renders a line, the photo already on screen is moved into the new markup
   (if none is free, the new <img> gets the same URL, which is already in memory, so it paints at once).
   Data (photo URL, size, swatch URLs) comes from layout/theme.liquid -> window.esmeCartMedia.
   The colour swatches in the cart are pure CSS (esme-cart.css + theme.liquid), so they follow the select instantly. */
(() => {
  const M = window.esmeCartMedia;
  if (!M || !M.img || window.__esmeCartPhoto) return;
  window.__esmeCartPhoto = 1;
  const abs = u => { try { return new URL(u, location.href).href; } catch (e) { return u; } };
  const IMG = abs(M.img);
  const PHOTO = 'img.kaching-cart-item__image';
  const pathOf = u => { try { return new URL(u, location.href).pathname.replace(/\/$/, ''); } catch (e) { return ''; } };
  const isTank = img => {
    const it = img.closest('#kaching-cart .kaching-cart-item');
    if (!it) return false;
    if (it.querySelector('[data-product-id="' + M.productId + '"]')) return true;
    const a = img.closest('a[href]') || it.querySelector('a[href*="/products/"]');
    return !!a && pathOf(a.getAttribute('href')) === '/products/' + M.handle;
  };
  const shown = img => img.dataset.esmePhoto && img.src === IMG && img.complete && img.naturalWidth > 0;
  let spare = [];
  const fix = img => {
    if (img.dataset.esmePhoto && img.src === IMG) return;
    if (!isTank(img)) return;
    const old = spare.pop();
    if (old) { old.className = img.className; img.replaceWith(old); return; }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('width', M.w);
    img.setAttribute('height', M.h);
    img.setAttribute('loading', 'eager');
    img.dataset.esmePhoto = '1';
    if (img.src !== IMG) img.src = IMG;
  };
  const scan = () => document.querySelectorAll('#kaching-cart ' + PHOTO).forEach(fix);
  new MutationObserver(ms => {
    let run = false;
    for (const m of ms) {
      if (!window.__esmeInCart(m)) continue; /* Speed fix Oct 19: ignore changes outside the Kaching cart */
      if (m.type === 'attributes') { run = run || m.target.matches(PHOTO); continue; }
      if (m.addedNodes.length) run = true;
      m.removedNodes.forEach(n => {
        if (n.nodeType !== 1) return;
        (n.matches(PHOTO) ? [n] : n.querySelectorAll(PHOTO)).forEach(i => { if (!i.isConnected && shown(i)) spare.push(i); });
      });
    }
    if (run) scan();
    spare = [];
  }).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['src']});
  scan();
  /* Warm the cache once (tiny files) so the photo and every swatch paint instantly when the cart opens or a colour changes. */
  const warm = () => { window.__esmeWarm = [M.img].concat(M.swatches || []).map(u => { const i = new Image(); i.src = u; return i; }); };
  const later = () => (window.requestIdleCallback ? requestIdleCallback(warm, {timeout: 3000}) : setTimeout(warm, 1500));
  document.readyState === 'complete' ? later() : window.addEventListener('load', later, {once: true});
})();

/* Row labels in a bundle: green FREE tag on the free tanks, #1, #2, #3 on the paid ones.
   Which tanks are free is Kaching's decision: it marks them with its gift emoji (.kaching-cart-item__variant-index-gift-emoji),
   on the lines whose price is discounted to $0. We keep that flag and only change what is shown (styles in esme-cart.css).
   Lines without any free tank (Buy 1) are left untouched. Re-applied whenever Kaching re-renders the cart. */
(()=>{if(window.__esmeRowOrder)return;window.__esmeRowOrder=window.__esmeFreeTag=1;
/* Esme: bundle rows keep their place (replaces the old gift-emoji FREE tag below).
   Kaching changes a colour/size by adding a NEW cart line (Shopify lists it first) and its discount makes the first line(s) free,
   so the changed tank used to jump into the FREE row. Every tank costs the same, so each row keeps its slot (remembered in
   sessionStorage "esmeRowSlots" by colour/size) and the FREE tag goes on the last 1 (Buy 2 Get 1) or 2 (Buy 3 Get 2) rows by position.
   Kaching re-uses row elements, so a select can keep a stale colour/size; it is reset from the row's real variant when the cart is idle. */
const ROW=".kaching-variant-selectors-row",GIFT=".kaching-cart-item__variant-index-gift-emoji",SK="esmeRowSlots",H=document.documentElement;
let mem={};try{mem=JSON.parse(sessionStorage.getItem(SK))||{}}catch(e){}
const save=()=>{try{sessionStorage.setItem(SK,JSON.stringify(mem))}catch(e){}},
busy=()=>H.classList.contains("esme-busy")||!!(window.__esmeCart&&(window.__esmeCart.busy||window.__esmeCart.inflight)),
sel=r=>[...r.querySelectorAll("select")],picked=r=>sel(r).map(s=>s.value).join("/"),
opts=r=>{const it=((window.kachingCartApi&&kachingCartApi.getCartData&&kachingCartApi.getCartData()||{}).items||[]).find(i=>String(i.variant_id)===r.dataset.variantId);return it&&it.options_with_values||null},
key=r=>{if(r.__esmeFrom&&r.__esmeFrom===r.dataset.variantId&&busy())return picked(r);const o=opts(r);return o?o.map(x=>x.value).join("/"):picked(r)||r.dataset.variantId||""},
fix=r=>{r.__esmeFrom=null;const o=opts(r);o&&sel(r).forEach(s=>{const v=(o.find(x=>x.name===s.dataset.optionName)||{}).value;v&&s.value!==v&&[...s.options].some(x=>x.value===v)&&(s.value=v)})},
label=(r,want)=>{const ix=r.querySelector(".kaching-variant-selectors-row__index");if(!ix)return;let l=ix.querySelector(":scope > .esme-row-label");if(want===null){l&&l.remove();return}l||(l=document.createElement("span"),l.className="esme-row-label",ix.appendChild(l));l.dataset.v!==want&&(l.dataset.v=want,want==="FREE"?l.innerHTML='<span class="esme-free-tag">FREE</span>':l.textContent=want)};
function sync(){let bi=0,dirty=!1;const idle=!busy();document.querySelectorAll("#kaching-cart .kaching-cart-item").forEach(item=>{const rows=[...item.querySelectorAll(ROW)];if(!rows.length)return;idle&&rows.forEach(fix);const id=(rows[0].dataset.productId||"")+":"+bi,prev=mem[id],gifts=rows.filter(r=>r.querySelector(GIFT)).length;
if(rows.length<2||!(gifts||prev&&prev.f&&prev.k.length===rows.length)){rows.forEach(r=>{label(r,null);r.style.order&&(r.style.order="")});return}
bi++;const F=gifts||prev.f,keys=rows.map(key),n=rows.length,used=keys.map(()=>!1),slot=[];let hit=0,order;
prev&&prev.k.forEach((k,s)=>{const i=keys.findIndex((x,j)=>!used[j]&&x===k);i>-1&&(used[i]=!0,slot[s]=i,hit++)});
if(hit){const rest=keys.map((x,j)=>j).filter(j=>!used[j]);for(let s=0;s<prev.k.length&&rest.length;s++)slot[s]===void 0&&(slot[s]=rest.shift());order=slot.filter(i=>i!==void 0).concat(rest)}
else{const free=rows.map((r,j)=>j).filter(j=>rows[j].querySelector(GIFT));order=rows.map((r,j)=>j).filter(j=>!free.includes(j)).concat(free)}
order.forEach((i,p)=>{const r=rows[i],o=String(1+p);r.__esmeSlot={id,p};r.style.order!==o&&(r.style.order=o);label(r,p>=n-F?"FREE":"#"+(p+1))});
const k=order.map(i=>keys[i]);idle&&(!prev||prev.f!==F||prev.k.join("|")!==k.join("|"))&&(mem[id]={k,f:F},dirty=!0)});dirty&&save()}
/* Speed fix Oct 19: same check as before, but sync() runs at most once per frame (was: on every DOM change batch) */
let syncQ=!1;new MutationObserver(ms=>{!syncQ&&ms.some(m=>(m.addedNodes.length||m.removedNodes.length)&&m.target.closest&&m.target.closest("#kaching-cart")&&!m.target.closest(".esme-row-label"))&&(syncQ=!0,requestAnimationFrame(()=>{syncQ=!1;sync()}))}).observe(H,{childList:!0,subtree:!0});
document.addEventListener("change",e=>{const r=e.target.closest&&e.target.closest("#kaching-cart "+ROW),t=r&&r.__esmeSlot,m=t&&mem[t.id];if(!r)return;r.__esmeFrom=r.dataset.variantId;m&&m.k[t.p]!==void 0&&(m.k[t.p]=picked(r),save());setTimeout(sync,0)},!0);
document.addEventListener("kaching-cart:cart-updated",()=>setTimeout(sync,0));
setInterval(()=>{!document.hidden&&document.querySelector("#kaching-cart "+ROW)&&!busy()&&sync()},1500); /* Speed fix Oct 19: skips while the tab is hidden */
document.readyState==="loading"?document.addEventListener("DOMContentLoaded",sync):sync()})();
(() => {
  if (window.__esmeFreeTag) return;
  window.__esmeFreeTag = 1;
  const GIFT = '.kaching-cart-item__variant-index-gift-emoji';
  const sync = () => document.querySelectorAll('#kaching-cart .kaching-cart-item').forEach(item => {
    const rows = [...item.querySelectorAll('.kaching-variant-selectors-row')];
    const isFree = r => !!r.querySelector(GIFT);
    const bundle = rows.some(isFree);
    let n = 0;
    rows.forEach(r => {
      const ix = r.querySelector('.kaching-variant-selectors-row__index');
      if (!ix) return;
      let lab = ix.querySelector(':scope > .esme-row-label');
      if (!bundle) { if (lab) lab.remove(); return; }
      const want = isFree(r) ? 'FREE' : '#' + (++n);
      if (!lab) { lab = document.createElement('span'); lab.className = 'esme-row-label'; ix.appendChild(lab); }
      if (lab.dataset.v !== want) {
        lab.dataset.v = want;
        if (want === 'FREE') lab.innerHTML = '<span class="esme-free-tag">FREE</span>';
        else lab.textContent = want;
      }
    });
  });
  new MutationObserver(ms => {
    if (ms.some(m => (m.addedNodes.length || m.removedNodes.length) && m.target.closest && m.target.closest('#kaching-cart') && !m.target.closest('.esme-row-label'))) sync();
  }).observe(document.documentElement, {childList: true, subtree: true});
  sync();
})();
